import React from 'react';
import {MoonLoader} from "react-spinners";

function Loader({})
{
    return <div style={{display: "flex", justifyContent: "center", alignItems: "center", flex: 1, width: "100%", height: "100%"}}><MoonLoader color="#36d7b7" /></div>
}

export default Loader;
